import React, { useEffect, useState } from 'react'
import { InputField } from '../../components/Input'
import AuthLayout from '../../layouts/AuthLayout'
import { Link, useNavigate } from 'react-router-dom';
import { signUp } from '../../adapters/authentication';
import signupRequest from '../../requests/signup';
import { showAlert } from '../../utils/alert';
import { ErrorStatus } from '../../components/FormStatus';


export default function Signup() {

  const navigate = useNavigate();


  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState([]);
  const [passwordStrengthBar, setPasswordStrengthBar] = useState(false);

  useEffect(() => {
    if(password !== ''){
      setPasswordStrengthBar(true)
    }
  }, [password])

  const register = async () => {
    await signupRequest.validate({ name, email, password}).then(() => {
        signUp({ name, email, password }).then((res) => {
          showAlert('success', 'Good Job', 'Account created successfully', () => {
            navigate("/auth/sign-in", { replace: true })
          })
      }).catch((err) => {
        setErrors(['Record already exists']);
      })
    }).catch((err) => {
        setErrors(err.errors);
    });
  }
  return (
    <AuthLayout title="Sign Up">
      <ErrorStatus errors={errors} />
      <form onSubmit={(e) => {
        e.preventDefault();
        register();
      }}>
        <InputField type="text" placeholder="John Doe" onChange={(e) =>  {
          setErrors([]);
          setName(e.target.value)
        }} defaultValue="" name="text" id="text" label="Full name" />
        <InputField type="email" placeholder="username@domain.com" onChange={(e) =>  {
          setErrors([]);
          setEmail(e.target.value)
        }} defaultValue="" name="email" id="email" label="Email" />
        <InputField type="password" placeholder="*********" showStrength={passwordStrengthBar} compareStrength={password} onChange={(e) =>  {
          setErrors([]);
          setPassword(e.target.value);
        }} defaultValue="" name="password" id="password" label="Password" />

        <div className="mt-6 px-3">
          <button className="py-3 font-fira hover:bg-blue-900 text-sm font-semibold w-full text-center flex justify-center items-center bg-blue-800 text-white rounded-lg " type="submit">
            Sign Up
          </button>
          <div className="mt-3 flex items-center justify-center w-full relative">
            <span className="absolute px-1 py-0 text-center mx-auto text-xs font-semibold"> Or </span>
          </div>
          <Link to="/auth/sign-in" className="py-3 font-fira mt-1 hover:text-blue-900  text-sm font-semibold w-full text-center flex justify-center items-center text-blue-800 rounded-lg " type="submit">
            Sign In
          </Link>
        </div>
      </form>
    </AuthLayout>
  )
}
